export default {"src":"/_next/static/media/LogoInstitutFrancais.6e54033f.svg","height":117,"width":191};